import React from 'react'

export default function InputFieldLabel(
   { id, label, htmlFor, className}
) {
  return (
    <div className="wth3-inputField__box">
        <label 
             {...(id ? { id } : {})}
             {...(htmlFor ? { htmlFor } : {})}

            className={`wth3-inputField__box-label ${className}`}
        >{label}</label>
    </div>
  )
}
